import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { Result } from '@digibricks/core';
import { Skill, SkillInstructions, OutputStructure } from '../../../../core';
export var SkillApiMapper = /*#__PURE__*/function () {
  function SkillApiMapper() {
    _classCallCheck(this, SkillApiMapper);
  }

  _createClass(SkillApiMapper, [{
    key: "toDomain",
    value: function toDomain(dto) {
      var _dto$name, _dto$actions;

      var instructionsResult = SkillInstructions.create(dto.instructions);

      if (instructionsResult.isFailure) {
        return Result.fail(instructionsResult.error);
      }

      var outputStructureResult = OutputStructure.fromJson(dto.outputStructure);

      if (outputStructureResult.isFailure) {
        return Result.fail(outputStructureResult.error);
      }

      return Skill.create({
        id: dto.id,
        name: (_dto$name = dto.name) !== null && _dto$name !== void 0 ? _dto$name : '',
        instructions: instructionsResult.getValue(),
        actions: (_dto$actions = dto.actions) !== null && _dto$actions !== void 0 ? _dto$actions : {},
        outputStructure: outputStructureResult.getValue(),
        llmProviderId: dto.llmProviderId,
        modelId: dto.modelId,
        required: dto.required,
        additionalProperties: dto.additionalProperties
      });
    }
  }]);

  return SkillApiMapper;
}();